import React from 'react';

import { BookingDetails } from '@components/utilities/Bookings/BookingDetails';

export const PastBookingDetails: React.FC = () => {
  return <BookingDetails type="past" />;
};
